import { render, staticRenderFns } from "./TranscriptQueueTask.vue?vue&type=template&id=81cf0992&scoped=true&"
import script from "./TranscriptQueueTask.vue?vue&type=script&lang=js&"
export * from "./TranscriptQueueTask.vue?vue&type=script&lang=js&"
import style0 from "./TranscriptQueueTask.vue?vue&type=style&index=0&id=81cf0992&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cf0992",
  null
  
)

export default component.exports